<template>
  <base-wrapper :loading="loadingSupplier || loadingJobStatus || loadingDelete">
    <div class="space-y-4">
      <div class="flex items-center justify-end space-x-2">
        <base-input
          type="search"
          placeholder="Cari Supplier"
          debounce
          :shadow="false"
          v-model="filter.search"
          @native-input="loadSupplier"
        />
        <base-button @click="onCreate" type="button">
          <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
          Tambah Supplier
        </base-button>
        <base-button :loading="loadingExport.visible" @click="onExport">
          <Icon
            v-if="!loadingExport.visible"
            icon="heroicons:arrow-down-tray"
            class="h-4 w-4"
          />
          {{ loadingExport.visible ? loadingExport.text : 'Export' }}
        </base-button>
      </div>
      <datatable
        :total="suppliersSummary.total"
        :perPage="suppliers.meta.page.perPage"
        :currentPage="currentPage"
        :meta="suppliers.meta"
        :columns="[
          { id: 'code', name: 'Kode Supplier' },
          { id: 'name', name: 'Nama Supplier' },
          { id: 'phone', name: 'Alamat / No. Telp' },
          { id: 'actions', name: 'Aksi' },
        ]"
        cursor
        @pagechanged="onPageChange"
        @prev="currentPage--"
        @next="currentPage++"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="supplier in suppliers.data"
            :key="supplier.id"
            :class="[classes.tr, 'bg-white hover:bg-gray-100']"
          >
            <td :class="[classes.td, 'cursor-pointer']" @click="onClickDetail(supplier)">
              <p class="font-bold text-gray-900">
                {{ supplier.attributes.code }}
              </p>
            </td>
            <td :class="[classes.td, 'cursor-pointer']" @click="onClickDetail(supplier)">{{ supplier.attributes.name }}</td>
            <td :class="[classes.td, 'cursor-pointer']" @click="onClickDetail(supplier)">
              <div>
                <p>
                  {{ getOfficeIncluded(supplier).attributes.full_address ?? '' }}
                </p>
                <p class="text-xs">
                  {{ getOfficeIncluded(supplier).attributes.phone ?? '' }}
                </p>
              </div>
            </td>
            <td :class="classes.td">
              <button
                v-if="!getOfficeIncluded(supplier).attributes.has_products"
                class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                @click="onDelete(supplier)"
              >
                <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
              </button>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <office-form-modal
      office-type="supplier"
      :visible="createModalVisible"
      @close="createModalVisible = false"
      @success="onSuccessCreate"
    />
    <view-office-modal
      office-type="supplier"
      :with-users="false"
      :loading="detailModal.loading"
      :visible="detailModal.visible"
      :office-id="detailModal.officeId"
      @close="detailModal.visible = false"
    >
      <template #additional-attributes="{ classes }">
        <div :class="classes.wrapper">
          <dt :class="classes.title">Produk</dt>
          <dd :class="classes.content">
            <datatable
              :columns="[
                { id: 'code', name: 'Kode Barang' },
                { id: 'name', name: 'Nama Barang' },
                { id: 'category', name: 'Kelompok Barang' },
              ]"
              :total="detailModal.products.meta.page.total"
              :perPage="detailModal.products.meta.page.perPage"
              :currentPage="detailModal.products.meta.page.currentPage"
              @pagechanged="onPageChangeProduct"
            >
              <template #tbody="{ classes }">
                <tr
                  v-for="product in detailModal.products.data"
                  :key="product.id"
                  :class="[classes.tr, 'bg-white hover:bg-green-100']"
                >
                  <td :class="classes.td">
                    <p class="font-bold text-gray-900">
                      {{ product.attributes.code }}
                    </p>
                  </td>
                  <td :class="classes.td">{{ product.attributes.name }}</td>
                  <td :class="classes.td">
                    {{ product.attributes.product_category_name ?? '-' }}
                  </td>
                </tr>
              </template>
            </datatable>
          </dd>
        </div>
      </template>
    </view-office-modal>

    <BaseConfirm
      :visible="supplierDeleteModal.visible"
      title="Hapus Supplier"
      message="Apakah anda yakin ingin menghapus supplier ini?"
      icon-type="badge"
      @close="supplierDeleteModal.visible = false"
      @confirmed="onConfirmDelete"
    />
  </base-wrapper>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import ViewOfficeModal from '@/components/office/view-office-modal.vue';
import OfficeFormModal from '@/components/office/office-form-modal.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { downloadFileUrl } from '../../../../../services/utils.service';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';

export default {
  name: 'Home',
  mixins: [requestMixin],
  components: {
    BaseButton,
    ViewOfficeModal,
    OfficeFormModal,
    BaseConfirm
  },
  data() {
    return {
      currentPage: 1,
      detailModal: {
        officeId: null,
        visible: false,
        loading: false,
        products: {
          data: [],
          meta: {
            page: {},
          },
        },
      },
      filter: {
        search: null,
      },
      loadingSupplier: false,
      loadingJobStatus: false,
      loadingDelete: false,
      suppliers: {
        data: [],
        meta: {
          page: {},
        },
      },
      suppliersSummary: {},
      createModalVisible: false,
      loadingExport: {
        visible: false,
        text: null,
      },
      supplierDeleteModal: {
        visible: false,
        supplierId: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      getChannelName: 'auth/getChannelName',
    }),
  },
  created() {
    this.loadJobStatus();
    this.loadSupplier();
    this.addListener()
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onClickDetail(simpleOffice) {
      this.detailModal.officeId = simpleOffice.relationships.office.data.id;
      this.detailModal.visible = true;

      this.loadSupplierProducts();
    },
    getOfficeIncluded(simpleOffice) {
      return this.getSingleIncluded(
        this.suppliers,
        simpleOffice.relationships.office.data.id
      );
    },
    onPageChange(page) {
      this.loadSupplier({
        ...page,
        'filter[with_summary]': false
      });
    },
    onPageChangeProduct(page) {
      this.loadSupplierProducts({
        'page[number]': page,
      });
    },
    onCreate() {
      this.createModalVisible = true;
    },
    onDelete(supplier) {
      this.supplierDeleteModal.supplierId = supplier.relationships.office.data.id;
      this.supplierDeleteModal.visible = true;
    },
    async onConfirmDelete() {
      this.loadingDelete = true;

      const [, error] = await this.request(`/api/v1/offices/${this.supplierDeleteModal.supplierId}`, {
        method: 'patch',
        data: {
          data: {
            type: 'offices',
            id: this.supplierDeleteModal.supplierId,
            attributes: {
              deletedAt: new Date
            }
          }
        } 
      });

      if (!error) {
        this.loadSupplier()
        this.supplierDeleteModal.visible = false
      }
       
      this.loadingDelete = false
    },
    async loadSupplierProducts(params) {
      this.detailModal.loading = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.detailModal.officeId}/products`,
        {
          params: {
            'page[size]': 5,
            'fields[products]': 'code,name,product_category_name',
            ...params,
          },
        }
      );

      if (!err) {
        this.detailModal.products = res;
      }

      this.detailModal.loading = false;
    },
    onSuccessCreate() {
      this.createModalVisible = false;
      this.loadSupplier();
    },
    async onExport() {
      this.startLoadingExport('Mengirim ke server');

      const [, err] = await this.request(
        `/api/v1/offices/-actions/export`,
        {
          method: 'post',
          params: {
            office_type: 'supplier',
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });

        this.stopLoadingExport();
      } else {
        this.startLoadingExport('Sedang diproses');
      }
    },
    onExportProgress(e) {
      if (e.type === 'App\\Notifications\\OfficeExported' && e.office_type === 'supplier') {
        if (e.status === 'failed') {
          this.stopLoadingExport();

          this.createAlert({
            data: 'Gagal mengexport supplier',
            status: 'error',
          });
        } else if (e.status === 'success') {
          this.stopLoadingExport();

          downloadFileUrl(e.file_url, 'supplier.csv', { blank: true });
        }
      }
    },
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onExportProgress
      );
    },
    async loadSupplier(params) {
      this.loadingSupplier = true;

      const [res, err] = await this.request('/api/v1/offices', {
        params: {
          'page[limit]': 5,
          'filter[office_category_id]': 6,
          include: 'office',
          'fields[simple-offices]': 'code,name,office',
          'fields[offices]': 'full_address,phone,has_products',
          'filter[search]': this.filter.search,
          'filter[with_summary]': true,
          ...params,
        },
      });

      if (!err) {
        this.suppliers = res;

        if (res.meta.summary) {
          this.suppliersSummary = res.meta.summary
        }

        if (!params) {
          this.currentPage = 1
        }
      }

      this.loadingSupplier = false;
    },
    async loadJobStatus() {
      this.loadingJobStatus = true;

      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'export_supplier',
          },
        }
      );

      if (!err) {
        const { running } = res;

        if (running) {
          this.startLoadingExport('Sedang Diproses');
        }
      }

      this.loadingJobStatus = false;
    },
    startLoadingExport(text) {
      this.loadingExport.text = text;
      this.loadingExport.visible = true;
    },
    stopLoadingExport() {
      this.loadingExport.visible = false;
    },
    removeExportListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onExportProgress
        );
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.removeExportListener();

    next();
  },
};
</script>
